import { mapGetters } from 'vuex'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faTooth } from '@fortawesome/free-solid-svg-icons'

library.add(
  faTooth,
)

const BitePostButton = {
  props: ['status', 'loggedIn'],
  data () {
    return {
      animated: false
    }
  },
  methods: {
    bitePost () {
      this.$store.dispatch('biteNote', this.status.id)
    }
  }
}

export default BitePostButton
